import React from "react";
import {
	AiOutlineGift,
	AiOutlineShopping,
	AiOutlineMobile,
} from "react-icons/ai";
import { FaLongArrowAltRight } from "react-icons/fa";

import {
	ShoppingLinkContainer,
	Row,
	Title,
	List,
	ImageContainer,
	SubTitle,
	Link,
	Container,
} from "../../styles/ShoppingLink";

function ShoppingLink(props) {
	return (
		<ShoppingLinkContainer>
			<Container className="container">
				<Row className="row">
					<Title className=" col col-12 col-sm-12 col-md-12 col-lg-12">
						stylish decor shopping, <br /> safe and easy
					</Title>

					<List className="col col-4 col-sm-4 col-md-4 col-lg-4">
						<ImageContainer>
							<AiOutlineGift />
						</ImageContainer>
						<SubTitle>
							<Link>
								Gifting made easy <br /> with our chic pieces
								<FaLongArrowAltRight style={{ fontSize: "10px" }} />
							</Link>
						</SubTitle>
					</List>

					<List className="col col-4 col-sm-4 col-md-4 col-lg-4">
						<ImageContainer>
							<AiOutlineShopping />
						</ImageContainer>
						<SubTitle>
							<Link>
								Enjoy fast, safe, <br /> contactless delivery
								<FaLongArrowAltRight style={{ fontSize: "10px" }} />
							</Link>
						</SubTitle>
					</List>

					<List className="col col-4 col-sm-4 col-md-4 col-lg-4">
						<ImageContainer>
							<AiOutlineMobile />
						</ImageContainer>
						<SubTitle>
							<Link>
								Choose from a wide collection
								<br /> of curated pieces
								<FaLongArrowAltRight style={{ fontSize: "10px" }} />
							</Link>
						</SubTitle>
					</List>
				</Row>
			</Container>
		</ShoppingLinkContainer>
	);
}

export default ShoppingLink;
